import React, { useState } from 'react';
import { View } from 'react-native-web';
import {
  Android, Both,
  create_button,
  create_send_popup,
  Customer,
  download_options,
  failed_send_popup,
  finished_send_popup, iOS,
  No_user,
  Paykey,
  publish_button,
  select_button,
  send_form_paragraph,
  send_form_text,
  send_form_title,
  uploading_send_popup,
  user,
} from '../utils/DictionaryManagementUtils';
import FullPagePanel from '../components/PanelsComponents/General/FullPagePanel';
import ArrowShapedButton from '../components/PanelsComponents/Buttons/ArrowShapedButton';
import BreakLine from '../components/PanelsComponents/General/BreakLine';
import RegularText from '../components/PanelsComponents/Text/RegularText';
import OpenBox from '../components/PanelsComponents/Buttons/OpenBox';
import LoadingPopup from '../components/PanelsComponents/Loading/LoadingPopup';
import SquareButton from '../components/PanelsComponents/Buttons/SquareButton';
import {
  img_send_button_create,
  img_send_button_publish_background,
  img_send_button_setting_background,
} from '../utils/ImagesManagementUtils';
import ActivityMenu from '../components/PanelsComponents/General/ActivityMenu';
import { getDateFormat, getUserVersion } from '../utils/Utils';

const Panel_Z01_send_form = ({
  globJSON,
  selectedUser,
  onConfigChanged,
  language,
  startExportingAllFiles,
  loggedInUserItem,
  simPlatform,
}) => {
  const [isBoxOpen, setBoxOpen] = useState(false);
  const [loadingState, setLoadingState] = useState({ title: '', loading: false });
  const url = 'https://us-central1-ui-deployment.cloudfunctions.net/release_client_from_wt';
  const os_type = () => {
    switch (simPlatform) {
      case Android:
        return 'android';
      case iOS:
        return 'ios';
      case Both:
        return 'both';
      default:
        return '';
    }
  };
  const createApp = (USER, USER_TYPE, OS_TYPE, ENV, CONFIG_VERSION) => fetch(
    url,
    {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        USER,
        USER_TYPE,
        OS_TYPE,
        ENV,
        CONFIG_VERSION,
      }),
    },
  );

  const sendToFirebase = async () => {
    prepareToPublish();
    await startExportingAllFiles({
      // All files to firebase
      forDownload: false,
      forAndroid: true,
      forIOS: true,
      handleImages: true,
      handleOther: true,
      forKeyboard: true,
      forOnboarding: true,
    });
  };

  const prepareToPublish = () => {
    globJSON.published_by = loggedInUserItem.userEmail;
    globJSON.last_published_at = getDateFormat();
    globJSON.firebase_version += 1;
    globJSON.firebase_version_path = getUserVersion(globJSON);
  };

  const publish = async () => {
    if (selectedUser) {
      setLoadingState({ title: uploading_send_popup(globJSON.bank_name), loading: true });
      await sendToFirebase();
      setLoadingState({ title: finished_send_popup(globJSON.bank_name, globJSON.firebase_version_path), loading: false });
    } else {
      setLoadingState({ title: No_user, loading: false });
    }
  };
  const sendAndCreate = async () => {
    if (selectedUser) {
      setLoadingState({ title: uploading_send_popup(globJSON.bank_name), loading: true });
      globJSON.sdk_created_by = loggedInUserItem.userEmail;
      globJSON.last_sdk_created_at = getDateFormat();
      await sendToFirebase();
      setLoadingState({ title: create_send_popup(globJSON.bank_name), loading: true });
      const env = process.env.BACKEND_URL && process.env.BACKEND_URL.includes('stag') ? 'staging' : 'production';
      await createApp(selectedUser.userUsername, selectedUser.userType === user ? Customer : Paykey,
        os_type(), env, selectedUser.firebase_version_path)
        .then((response) => {
          if (response.ok) {
            setLoadingState({ title: finished_send_popup(globJSON.bank_name, globJSON.firebase_version_path), loading: false });
          } else {
            setLoadingState({ title: failed_send_popup(globJSON.bank_name, globJSON.firebase_version_path), loading: false });
            console.log(response);
          }
        }).catch((error) => {
          setLoadingState({ title: failed_send_popup(globJSON.bank_name, globJSON.firebase_version_path), loading: false });
          console.error(error);
        });
    } else {
      setLoadingState({ title: No_user, loading: false });
    }
  };

  const onNewSelection = (newSelection) => {
    switch (newSelection) {
      case 'android_image_files':
        startExportingAllFiles({
          // Android-Image-files DOWNLOAD
          forDownload: true,
          forAndroid: true,
          forIOS: false,
          handleImages: true,
          handleOther: false,
          forKeyboard: true,
          forOnboarding: false,
        });
        break;
      case 'android_other_files':
        startExportingAllFiles({
          // Android-Other-files DOWNLOAD
          forDownload: true,
          forAndroid: true,
          forIOS: false,
          handleImages: false,
          handleOther: true,
          forKeyboard: true,
          forOnboarding: false,
        });
        break;

      case 'iOS_Image_files':
        startExportingAllFiles({
          // iOS-Image-files DOWNLOAD
          forDownload: true,
          forAndroid: false,
          forIOS: true,
          handleImages: true,
          handleOther: false,
          forKeyboard: true,
          forOnboarding: false,
        });
        break;
      case 'iOS_Other_files':
        startExportingAllFiles({
          // iOS-Other-files DOWNLOAD
          forDownload: true,
          forAndroid: false,
          forIOS: true,
          handleImages: false,
          handleOther: true,
          forKeyboard: true,
          forOnboarding: false,
        });
        break;

      case 'Android_onboarding':
        startExportingAllFiles({
          // Android-Onboarding DOWNLOAD
          forDownload: true,
          forAndroid: true,
          forIOS: false,
          handleImages: true,
          handleOther: true,
          forKeyboard: false,
          forOnboarding: true,
        });
        break;
      case 'iOS_onboarding':
        startExportingAllFiles({
          // iOS-Onboarding DOWNLOAD
          forDownload: true,
          forAndroid: false,
          forIOS: true,
          handleImages: true,
          handleOther: true,
          forKeyboard: false,
          forOnboarding: true,
        });
        break;
      default:
    }
  };

  return (
    <FullPagePanel
      globJSON={globJSON}
      onConfigChanged={onConfigChanged}
      panelHeadline={send_form_title}
      paragraph={send_form_paragraph}
      tooltipsTitles={globJSON.configurations.theme.screens_ordering}
      disableEditElements
      language={language}
      paddingVertical={25}
    >

      <View style={{ flexDirection: 'row' }}>
        <ArrowShapedButton background={img_send_button_setting_background} isSetting />
        <ArrowShapedButton
          title={publish_button}
          onPress={publish}
          background={img_send_button_publish_background}
        />
        <ArrowShapedButton
          title={create_button}
          onPress={sendAndCreate}
          background={img_send_button_create}
          darkTheme
        />
      </View>
      <BreakLine marginTop={30} />
      <ActivityMenu globJSON={globJSON} />
      <BreakLine marginTop={30} />
      <RegularText isSemiBold>{send_form_text}</RegularText>
      <SquareButton
        title={select_button}
        showToggleButton
        onPress={() => {
          if (!isBoxOpen) {
            setBoxOpen(!isBoxOpen);
          }
        }}
      />

      {isBoxOpen && (
        <View>
          <OpenBox
            right={260}
            top={0}
            language={language}
            valuesMap={download_options}
            onPress={() => {
              setBoxOpen(!isBoxOpen);
            }}
            onValueChanged={(newSelection) => onNewSelection(newSelection)}
          />
        </View>
      )}
      {loadingState.title && (
        <LoadingPopup
          onPressed={() => setLoadingState({ title: '', loading: false })}
          title={loadingState.title}
          language={language}
          isLoading={loadingState.loading}
        />
      )}
    </FullPagePanel>
  );
};
export default Panel_Z01_send_form;
